import { h, render, Component } from 'preact';
import { translate } from 'react-i18next';

const locale = {
	labelUsername: 'Username',
	labelPassword: 'Password',
	labelConfirm: 'Confirm',
	labelEmail: 'Email',
	labelRecovery: 'Recovery Code',
	labelTwoFactor: 'Two Factor Code',
	labelAuth: 'Authentication Code',
	labelAge: 'I am 13+ years old and I agree to the <a href="https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2015/11/Hi-Rez-Studios-Online-Terms-of-Service-and-Use-Agreement-Last-updated-Aug.-24-2017.pdf" rel="noopener noreferrer" target="_blank">Terms of Service</a>.',
	labelSubscribe: 'Send me Hi-Rez Studios news.',
	copyCantLogin: 'Can\'t Login?',
	copyDivider: 'or',
	copyServicesSignup: 'Sign Up With:',
	copyServicesLogin: 'Login With:',
	copyContactSupport: 'If the above options were not able to assist you:',
	btnLogin: 'Login',
	btnCreate: 'Create',
	btnCreateFree: 'Create A Free Account',
	btnSubmit: 'Submit',
	btnGoogle: 'Google',
	btnFacebook: 'Facebook',
	btnBack: 'Back',
	btnRecoverUsername: 'Forgot Your Username?',
	btnRecoverPassword: 'Forgot Your Password?',
	btnRecoverCode: 'Use One Time Recovery Code',
	btnBackupEmail: 'Use Backup Email to Login',
	btnContactSupport: 'Contact Customer Support',
	smiteCopy: 'Sign Up Now! Join 25+ Million Players Today',
	errorUsernameMissing: 'A username is required to create an account.',
	panelCopyCantLogin: 'There are several reasons you might not be able to log in. The options below may be able to assist you in recovering your account.',
	panelCopyForgotUsername: 'Enter in the email associated with your account to receive a reminder email.',
	panelCopyForgotPassword: 'Enter in the email and username associated with your account to reset your password.',
	panelCopyRecoveryCode: 'Enter in the username and one time recovery code (when you setup your two factor authentication) to login.',
	panelCopyBackupEmail: 'Enter in the username and password to login. Your two factor authorization code will be sent to your backup email.',
	panelCopyCreateGoogle: 'A verified email address with Google is required to create an account. You will use your Google login to play.',
	panelCopyCreateFacebook: 'A verified email address with Facebook is required to create an account. You will use your Facebook login to play.',
	panelCopyLoginThirdParty: 'You will be logged in as:',
	forgotResponse: 'Thank you, an email has been sent to the address on file.',
	noMasterAccount: 'We were not able to find a linked Hi-Rez Studios account. Would you like to link this account?'
};

class NoMasterAcct extends Component {
	changeView = (view) => {
		this.setState({
			error: undefined,
			username: undefined,
			password: undefined,
			email: undefined,
			age: undefined,
			subscribe: undefined
		 });
		this.setState({ linkView: view });
	}

	constructor(props) {
		super(props);
		this.state = {
			buttonSupportState: 'initial',
			linkView: 'login'
  	};
	}

	getURLParam = ( name, url ) => {
		if (!url) url = location.href;
		name = name.replace(/[\[]/,'\\\[').replace(/[\]]/,'\\\]');
		let regexS = '[\\?&]'+name+'=([^&#]*)';
		let regex = new RegExp( regexS );
		let results = regex.exec( url );
		return results == null ? null : results[1];
	}

	// create cookie
	createCookie = (name, value, days) => {
		let expires;
		if (days) {
			let date = new Date();
			date.setTime(date.getTime()+(days*24*60*60*1000));
			expires = '; expires='+date.toGMTString();
		}
		else {
			expires = '';
		}
		document.cookie = name + "=" + value + expires +";path=/";
	}

	linkThirdPartyAccount = (platform,accessToken,webToken) => {
		fetch(`https://api.hirezstudios.com/acct/decryptToken`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: `{"token": "${accessToken}"}`
		}).then((response) => response.json()).then((response) => {
			if (response.decryptedToken) {
				let decryptedToken = response.decryptedToken;
				fetch(`https://api.hirezstudios.com/acct/linkNew`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: `{"token":"${decryptedToken}", "platform":"${platform}", "webToken":"${webToken}"}`
				}).then((response) => response.json()).then((response) => {
					if (response.statusCode === 200) {
						this.createCookie('HZAcctWebToken', webToken, 30);
						location.reload();
					}
					else if (response.statusCode === 400) {
						this.setState({ error: 'Your third party account is already linked to an existing Hi-Rez Studios account.' });
					}
					else {
						this.setState({ error: 'Something went wrong. Please try again.' });
					}
				});
			}
			else {
				this.setState({ error: 'Something went wrong. Please try again.' });
			}
		});
	}

	linkSteamAccount = (accessToken,webToken) => {
		fetch(`https://api.hirezstudios.com/acct/decryptToken`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: `{"token": "${accessToken}"}`
		}).then((response) => response.json()).then((response) => {
			if (response.decryptedToken) {
				let decryptedToken = response.decryptedToken;
				fetch(`https://api.hirezstudios.com/acct/linkSteam`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: `{"token":"${decryptedToken}", "platform":"steam", "webToken":"${webToken}"}`
				}).then((response) => response.json()).then((response) => {
					if (response.statusCode === 200) {
						this.createCookie('HZAcctWebToken', webToken, 30);
						location.reload();
					}
					else if (response.statusCode === 400) {
						this.setState({ error: 'Your third party account is already linked to an existing Hi-Rez Studios account.' });
					}
					else {
						this.setState({ error: 'Something went wrong. Please try again.' });
					}
				});
			}
			else {
				this.setState({ error: 'Something went wrong. Please try again.' });
			}
		});
	}

	validateLoginData = (username,password) => {
		if (!username || username === undefined || username === null) {
			this.setState({ error: 'Username is a required field.' });
			return false;
		}
		if (!password || password === undefined || password === null) {
			this.setState({ error: 'Password is a required field.' });
			return false;
		}
		return true;
	}

	validateCreateData = (username,password,email,age) => {
		let emailValidation = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if (!username || username === undefined || username === null) {
			this.setState({ error: 'Username is a required field.' });
			return false;
		}
		if (!password || password === undefined || password === null) {
			this.setState({ error: 'Password is a required field.' });
			return false;
		}
		if (!email || password === undefined || password === null) {
			this.setState({ error: 'Email is a required field.' });
			return false;
		}
		if (emailValidation.test(String(email).toLowerCase()) !== true) {
			this.setState({ error: 'Please enter a valid email address.' });
			return false;
		}
		if (!age || age === undefined || age === null) {
			this.setState({ error: 'You must be at least 13 years old and agree to the Terms of Service to create an account.' });
			return false;
		}
		return true;
	}

	attemptLogin = (e) => {
		e.preventDefault();
		let username = this.state.username;
		let password = this.state.password;
		if (this.validateLoginData(username,password)) {
			fetch(`https://api.hirezstudios.com/acct/login`, {
				method: `POST`,
				headers: {
					'Content-Type': 'application/json'
				},
				body: `{"username":"${username}","password":"${password}"}`
			}).then((response) => response.json()).then((response) => {
				if (response.hasOwnProperty('webToken')) {
					let platform = this.getURLParam('platform');
					if (platform == 'playstation') {
						platform = 'ps4';
					}
					let accessToken = this.getURLParam('accessToken');
					if (platform === 'steam') {
						this.linkSteamAccount(accessToken,response.webToken);
					}
					else {
						this.linkThirdPartyAccount(platform,accessToken,response.webToken);
					}
				}
				else if (response.hasOwnProperty('errors')) {
					this.setState({ error: response.errors[0] });
				}
				else {
					this.setState({ error: 'Something went wrong. Please try again.' });
				}
			});
		}
	}

	attemptCreate = (e) => {
		e.preventDefault();
		let username = this.state.username;
		let password = this.state.password;
		let email = this.state.email;
		let age = this.state.age;
		let subscribe = this.state.subscribe;
		if (this.validateCreateData(username,password,email,age)) {
			fetch(`https://api.hirezstudios.com/acct/create`, {
				method: `POST`,
				headers: {
					'Content-Type': 'application/json'
				},
				body: `{"username":"${username}","password":"${password}","confirmPassword":"${password}","email":"${email}","over13":"true","subscribe":"${subscribe}"}`
			}).then((response) => response.json()).then((response) => {
				if (response.hasOwnProperty('webToken')) {
					let platform = this.getURLParam('platform');
					if (platform == 'playstation') {
						platform = 'ps4';
					}
					let accessToken = this.getURLParam('accessToken');
					if (platform === 'steam') {
						this.linkSteamAccount(accessToken,response.webToken);
					}
					else {
						this.linkThirdPartyAccount(platform,accessToken,response.webToken);
					}
				}
				else if (response.hasOwnProperty('errors')) {
					this.setState({ error: response.errors[0] });
				}
				else {
					this.setState({ error: 'Something went wrong. Please try again.' });
				}
			});
		}
	}

	render() {
		const { t } = this.props;
  	return (
  		<div className="v-NoMasterAcct">
				<div className="inputs-wrapper">
					<p>{t(locale.noMasterAccount)}</p>
					<div className="error-message">{this.state.error}</div>
					<div className="view-selectors">
						<div onClick={() => this.changeView('login')} className={`view ${this.state.linkView === 'login' ? 'active' : ''}`}>{t('Link An Existing Account')}</div>
						<div onClick={() => this.changeView('create')} className={`view ${this.state.linkView === 'create' ? 'active' : ''}`}>{t('Link A New Account')}</div>
					</div>
					<div className="form-wrappers">
						{ this.state.linkView === 'login' &&
							<div className="form link-login">
								<div className="username-wrapper">
									<label htmlFor="username">{t(locale.labelUsername)}</label>
									<input
										type="text"
										id="username"
										onInput={e => this.setState({ username: e.target.value })}
										value={this.state.username}
									/>
								</div>
								<div className="password-wrapper">
									<label htmlFor="username">{t(locale.labelPassword)}</label>
									<input
										type="password"
										id="password"
										onInput={e => this.setState({ password: e.target.value })}
										value={this.state.password}
									/>
								</div>
								<div className="actions-wrapper">
									<div className="submit">
										<input type="submit" value={t(locale.btnLogin)} onClick={this.attemptLogin} className="login-btn" />
									</div>
									<div className="loading" />
								</div>
							</div>
						}
						{ this.state.linkView === 'create' &&
						<div className="form link-create">
							<div className="username-wrapper">
								<label htmlFor="username">{t(locale.labelUsername)}</label>
								<input
									type="text"
									id="username"
									onInput={e => this.setState({ username: e.target.value })}
									value={this.state.username}
								/>
							</div>
							<div className="password-wrapper">
								<label htmlFor="username">{t(locale.labelPassword)}</label>
								<input
									type="password"
									id="password"
									onInput={e => this.setState({ password: e.target.value })}
									value={this.state.password}
								/>
							</div>
							<div className="email-wrapper">
								<label htmlFor="email">{t(locale.labelEmail)}</label>
								<input
									type="text"
									id="email"
									onInput={e => this.setState({ email: e.target.value })}
									value={this.state.email}
								/>
							</div>
							<div className="age-wrapper">
								<input
									type="checkbox"
									id="age"
									onInput={e => this.setState({ age: e.target.value })}
									value={this.state.age}
								/>
								<label htmlFor="age" dangerouslySetInnerHTML={{ __html: t(locale.labelAge) }} />
							</div>
							<div className="subscribe-wrapper">
								<input
									type="checkbox"
									id="subscribe"
									onInput={e => this.setState({ subscribe: e.target.value })}
									value={this.state.subscribe}
								/>
								<label htmlFor="subscribe">{t(locale.labelSubscribe)}</label>
							</div>
							<div className="actions-wrapper">
								<div className="submit">
									<input type="submit" value={t(locale.btnCreate)} onClick={this.attemptCreate} className="login-btn" />
								</div>
								<div className="loading" />
							</div>
						</div>
						}
					</div>
					<div className="cancel-link">
						<div onClick={() => this.props.callback('login', this.state.panel)} className="warning" dangerouslySetInnerHTML={{__html: t('Wrong account? <a>Login to a different account.</a>') }} />
					</div>
				</div>
  		</div>
  	);
	}
}

export default translate(['common'], { withRef: true })(NoMasterAcct);


// WEBPACK FOOTER //
// ./components/LoginPanelNoMaster.js